
<template>
	<div @click="focusNewTag()" :class="{'read-only': readOnly,'vue-input-tag-wrapper--active': isInputActive || isTagActive}" class="vue-input-tag-wrapper">
		<span v-for="(tag, index) in innerTags" :key="index" 
			class="input-tag" :class="{highlight2: highlightFrom>-1 && index>=highlightFrom}">
			<span>{{ tag }}</span>
			<button v-if="!readOnly" @click.prevent.stop="remove(index)" class="remove" @blur ="handleTagBlur" @focus="handleTagFocus"></button>
		</span>
		<input v-if="!readOnly && !isLimit" ref="inputtag" :placeholder="placeholder" type="text" v-model="newTag" 
			v-on:keydown.delete.stop="removeLastTag" v-on:keydown="addNew" v-on:blur ="handleInputBlur" v-on:focus="handleInputFocus" class="new-tag"/>
  </div>
</template>

<script>
	const validators = {
  		email: new RegExp(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/),
  		url: new RegExp(/^(https?|ftp|rmtp|mms):\/\/(([A-Z0-9][A-Z0-9_-]*)(\.[A-Z0-9][A-Z0-9_-]*)+)(:(\d+))?\/?/i),
  		text: new RegExp(/^[a-zA-Z]+$/),
  		digits: new RegExp(/^[\d() \.\:\-\+#]+$/),
  		isodate: new RegExp(/^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/)
	};

	export default {
		name: 'InputToken',
		props: {
			tags: {
				type: Array,
				default: () => []
			},
			placeholder: {
				type: String,
				default: ''
			},
			readOnly: {
				type: Boolean,
				default: false
			},
			validation: {
				type: String | Object,
				default: ''
			},
			addTagOnKeys: {
				type: Array,
				default: function () {
					//return [13, 188, 9]; //return, comma, tab
					return [13, 188, 32]; //return, comma, space
				}
			},
			addTagOnBlur: {
				type: Boolean,
				default: false
			},
			limit: {
				default: -1
			},
			highlightFrom: {
				type: Number,
				default: -1
			}
		},

		data () {
			return {
				newTag: '',
				innerTags: [...this.tags],
				isInputActive: false,
				isTagActive: false
			}
		},

		watch: {
			tags () {
				this.innerTags = [...this.tags]
			}
		},

		computed: {
			isLimit: function () {
				return this.limit > 0 && Number(this.limit) === this.innerTags.length;
			}
		},

		methods: {
			focusNewTag () {
				if (this.readOnly || !this.$el.querySelector('.new-tag')) return;
				this.$el.querySelector('.new-tag').focus();
			},
			handleInputFocus () {
				this.isInputActive = true;
			},
			handleTagFocus () {
				this.isTagActive = true;
			},
			handleInputBlur (e) {
				this.isInputActive = false;
				this.addNew(e);
			},
			handleTagBlur() {
				this.isTagActive = false;
			},
			addNew (e) {
				// Do nothing if the current key code is
				// not within those defined within the addTagOnKeys prop array.
				if ((e && this.addTagOnKeys.indexOf(e.keyCode) === -1 && (e.type !== 'blur' || !this.addTagOnBlur)) || this.isLimit) return

				if (e) {
					e.stopPropagation();
					e.preventDefault();
				}

				if (this.newTag && this.innerTags.indexOf(this.newTag) === -1 && this.validateIfNeeded(this.newTag)) {
					this.innerTags.push(this.newTag);					
					this.newTag = '';
					this.tagChange();
				}
			},

			validateIfNeeded (tagValue) {
				if (this.validation === '' || this.validation === undefined) {
					return true;
				} 
				else if (typeof (this.validation) === 'string' && Object.keys(validators).indexOf(this.validation) > -1) {
					return validators[this.validation].test(tagValue);
				}
				else if (typeof (this.validation) === 'object' && this.validation.test !== undefined) {
					return this.validation.test(tagValue);
				}

				return true
			},

			remove (index) {
				this.innerTags.splice(index, 1);
				this.$el.querySelector('.new-tag').focus();
				this.tagChange();
			},

			removeLastTag () {
				if (this.newTag) return;
				this.innerTags.pop();
				this.tagChange();
			},

			tagChange () {
				this.$emit('update:tags', this.innerTags);
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/InputToken.vue